import { render, staticRenderFns } from "./CustomerNotificationPrioritaet.vue?vue&type=template&id=4bc76aa0"
import script from "./CustomerNotificationPrioritaet.vue?vue&type=script&lang=js"
export * from "./CustomerNotificationPrioritaet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports